import axios, { AxiosRequestHeaders } from "axios";

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:3010/",
});

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
    } as AxiosRequestHeaders;
    return config;
  },
  (error) => {
    console.log("Error in axios", error);
    return Promise.reject(error);
  }
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response.status === 401 &&
      !window.location.href.includes("/login")
    ) {
      window.location.pathname = "/login";
    }
    return Promise.reject(
      (error.response && error.response.data) || "Wrong Services"
    );
  }
);

export default axiosServices;
